import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Bot, Activity, Brain, Globe, Shield, Zap } from 'lucide-react';

const AGENT_ACTIONS = [
    "Fetching real-time market data from Polymarket CLOB",
    "Running multi-agent risk analysis model",
    "Simulating trade impact on liquidity pools",
    "Verifying on-chain transaction logs via RPC node",
    "Updating decentralized consensus vector",
    "Calibrating Bayesian probability shift",
    "Syncing trade state with Lobster Network mainnet",
    "Optimizing gas parameters for front-run protection",
    "Analyzing market sentiment across social channels",
    "Computing optimal entry/exit positions",
    "Monitoring whale wallet movements",
    "Validating smart contract execution paths"
];

const AGENT_NAMES = [
    "Claw_Node_01", "Lobster_Alpha", "Neural_Shell", "Bio_Sync_8",
    "Deep_Sea_Node", "Shell_Sentry", "Vortex_Agent", "Claw_Validator"
];

export const PostPredictionActivity = ({ isVisible }) => {
    const [logs, setLogs] = useState([]);

    useEffect(() => {
        if (isVisible) {
            // Add initial log immediately
            const initialAgent = AGENT_NAMES[Math.floor(Math.random() * AGENT_NAMES.length)];
            const initialAction = AGENT_ACTIONS[Math.floor(Math.random() * AGENT_ACTIONS.length)];
            setLogs([{
                id: Date.now(),
                agent: initialAgent,
                action: initialAction,
                time: new Date().toLocaleTimeString([], { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' })
            }]);

            const interval = setInterval(() => {
                const randomAgent = AGENT_NAMES[Math.floor(Math.random() * AGENT_NAMES.length)];
                const randomAction = AGENT_ACTIONS[Math.floor(Math.random() * AGENT_ACTIONS.length)];
                const newLog = {
                    id: Date.now(),
                    agent: randomAgent,
                    action: randomAction,
                    time: new Date().toLocaleTimeString([], { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' })
                };

                setLogs(prev => [newLog, ...prev].slice(0, 8));
            }, 3000);

            return () => clearInterval(interval);
        }
    }, [isVisible]);

    if (!isVisible) return null;

    return (
        <div className="p-3 space-y-2 font-mono text-[10px] min-h-[200px] max-h-[350px] overflow-y-auto custom-scrollbar">
            <AnimatePresence initial={false}>
                {logs.map((log) => (
                    <motion.div
                        key={log.id}
                        initial={{ opacity: 0, x: -10 }}
                        animate={{ opacity: 1, x: 0 }}
                        className="flex flex-col gap-1 border-l-2 border-secondary/30 pl-2 py-1.5 hover:bg-white/5 transition-colors rounded-r"
                    >
                        <div className="flex items-center gap-2">
                            <span className="text-secondary font-bold text-[11px]">{log.agent}</span>
                            <span className="text-white/20 text-[8px]">{log.time}</span>
                        </div>
                        <span className="text-white/70 text-[10px] leading-relaxed">{log.action}</span>
                    </motion.div>
                ))}
            </AnimatePresence>

            {logs.length === 0 && (
                <div className="flex flex-col items-center justify-center py-10 opacity-30">
                    <Activity className="w-8 h-8 text-secondary mb-2 animate-pulse" />
                    <p className="uppercase tracking-[0.2em] text-[9px]">Initiating Neural Link...</p>
                </div>
            )}
        </div>
    );
};
